import { render } from "./ProductFormDialog.vue?vue&type=template&id=2bb8fcc2&scoped=true"
import script from "./ProductFormDialog.vue?vue&type=script&lang=js"
export * from "./ProductFormDialog.vue?vue&type=script&lang=js"

import "./ProductFormDialog.vue?vue&type=style&index=0&id=2bb8fcc2&scoped=true&lang=css"

import exportComponent from "/Users/Zhuanz/Desktop/himoney/aidata/loan-management/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb8fcc2"]])

export default __exports__